import React, { Component } from 'react'
import '../stylesheets/main.scss'
import '../stylesheets/components/boards.scss'
import '../stylesheets/components/cardslist.scss'
import Card from './Card'

class Boards extends Component{

	constructor(props){
		super(props)

		this.state = {
			boards: [],
			olds: []
		}
	}

	componentWillMount(){
		fetch('https://www.serasaconsumidor.com.br/serasaitinerante/manager/api/v1/boards')
	      .then(response => response.json())
	      .then(data => this.setState({ boards: data }));

	    fetch('https://www.serasaconsumidor.com.br/serasaitinerante/manager/api/v1/boards/old')
	      .then(response => response.json())
	      .then(data => this.setState({ olds: data }));
	}

	render(){

		const itens = this.state.boards.map((item) => {
					      return (

				      			<Card
				      				key={ item.id }
				      				id = { item.id }
						          	cover = { item.cover }
						          	title = { item.title }
						          	resume = { item.resume }
						          	url = { item.url }
						          	published_at = { item.published_at }
						          	video = { item.is_video }
						          />
					      )
					    })

		const olds = this.state.olds.map((item) => {
					      return (

				      			<Card
				      				key={ item.id }
				      				id = { item.id }
						          	cover = { item.cover }
						          	title = { item.title }
						          	resume = { item.resume }
						          	url = { item.url }
						          	published_at = { item.published_at }
						          	video = { item.is_video }
						          />
					      )
					    })

		return (
			<div className="o-board" id="diario-de-bordo">
				<div className="o-container">
					<h1 className="c-title c-title--size-medium c-title--family-bold c-title--lineheight-2 c-title--color-grey c-title--align-center" >Diário de bordo</h1>
					<h2 className="c-title c-title--size-small c-title--family-regular c-title--lineheight-2 c-title--color-grey c-title--align-center c-title--border c-title--border-bottom-center" >
						Acompanhe a jornada do vencedor da primeira <br /> edição de “O Emprego dos Sonhos”:
					</h2>
					
					<div className="c-cards">
						<div className="c-cards__container">
							<div className="row" >
								<ul className="c-cards__list">
									{ itens }
								</ul>
							</div>
						</div>
					</div>

					<h1 className="c-title c-title--size-medium c-title--family-bold c-title--lineheight-2 c-title--color-grey c-title--align-left c-title--align-center-onmobile c-title--border c-title--border-bottom" >
						Mais antigos
					</h1>

					<div className="c-cards">
						<div className="c-cards__container">
							<div className="row" >
								<ul className="c-cards__list">
									{ olds }
								</ul>
							</div>
						</div>
					</div>

				</div>
			</div>
		)
	}

}

export default Boards


// WEBPACK FOOTER //
// ./src/components/Boards.js